//export const API_BASE_URL = `http://103.16.222.38/adminapi/index.php/`;
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
export const REACT_APP_API_NODE = process.env.REACT_APP_API_NODE;
//console.log(process.env.NODE_ENV    ,"fsdfdsfs");
//export const API_BASE_URL = `https://rightpe.com/adminapi/index.php/`;


